webpackJsonp([114276838955818,60335399758886],{

/***/ 125:
/***/ (function(module, exports) {

	module.exports = {"data":{"logo":null},"layoutContext":{}}

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(237);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(125);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(31);
	var isArguments = __webpack_require__(30);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 30:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(36);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(29);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(35);
	
	var _HelmetConstants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(32));
	var shallowEqual = _interopDefault(__webpack_require__(37));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Logo (props) {
	    return React.createElement("svg",props,[React.createElement("text",{"fill":"#313186","fontFamily":"'DINPro-Regular'","fontSize":"34","letterSpacing":"6","transform":"translate(167.4854 84.4473)","key":0},"WAVEY MEDIA GROUP"),React.createElement("g",{"fill":"#1dc1e5","key":1},[React.createElement("path",{"d":"m26.319 44.453s-.768 7.163-5.117 6.908c-4.349-.256-5.885-5.63-2.303-11.258s11.769-11.258 22.771-6.651c11.001 4.604 7.419 16.886 8.442 17.909 1.023 1.022 11.825 6.465 14.327-5.63 3.07-14.838 17.909-18.42 27.887-8.954 9.978 9.467-1.791 13.561 10.746 17.142 0 0 6.396 1.023 7.931-7.163 1.535-8.188 6.993-16.715 18.933-15.352 8.701.995 12.536 9.211 12.536 11.258 0 2.046 2.814 8.869-3.837 8.443-4.851-.312-.512-8.615-10.746-11.002-10.233-2.387-6.993 9.381-11.086 14.668-4.093 5.288-8.016 8.699-16.715 7.505-8.698-1.193-12.11-9.38-12.622-14.669-.511-5.286-7.228-11.735-13.304-5.457-5.117 5.288 1.535 13.986-12.962 19.784 0 0-10.916 2.9-16.204-4.604s-2.558-9.381-4.435-13.133c-1.876-3.753-10.404-6.822-14.242.256z","key":0}),React.createElement("path",{"d":"m36.553 89.481c-2.729-.426-1.629-.288-5.97-.682-1.876-.171-2.644-5.459-.341-7.505 1.786-1.588 5.547-1.396 11.428 1.107 8.613 3.668 6.97 16.552 8.954 18.271 1.919 1.663 11.313 6.103 13.815-5.991 3.07-14.838 17.909-18.42 27.887-8.954s-1.791 13.559 10.746 17.142c0 0 6.396 1.023 7.931-7.164s7.425-15.825 18.612-15.052c.618.043 1.3 1.108 1.727 2.431.628 1.947.576 3.966-.768 5.373-.238.248-.715.915-2.687.597-8.699-1.407-6.993 9.381-11.086 14.668s-8.016 8.699-16.715 7.505c-8.698-1.194-12.11-9.382-12.622-14.668-.511-5.287-7.228-11.736-13.304-5.459-5.117 5.288 1.535 13.986-12.962 19.786 0 0-10.916 2.899-16.204-4.605s-3.518-8.741-4.669-12.707c-.823-2.839-2.183-3.844-3.772-4.093z","key":1})])]);
	}
	
	Logo.defaultProps = {"enableBackground":"new 0 0 628 137","height":"137","viewBox":"0 0 628 137","width":"628"};
	
	module.exports = Logo;
	
	Logo.default = Logo;


/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\tbackground: #000;\n\n\t> .inner-wrap {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr;\n\t\tmax-width: 90vw;\n\t\tmargin: 0 auto;\n\t\tpadding: 40px 0px;\n\t\t', ';\n\t\t.footer-logo-wrap {\n\t\t\tsvg {\n\t\t\t\tmax-width: 270px;\n\t\t\t\theight: 60px;\n\n\t\t\t\ttext,\n\t\t\t\tg {\n\t\t\t\t\tfill: #fff;\n\t\t\t\t}\n\n\t\t\t\ttext {\n\t\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tcolor: #fff;\n\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\tfont-weight: 300;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tline-height: 20px;\n\t\t\t\tpadding: 0px 15px;\n\t\t\t}\n\t\t}\n\n\t\t.consult-wrap {\n\t\t\tpadding: 20px;\n\t\t\t', ';\n\t\t\th4 {\n\t\t\t\tcolor: #fff;\n\t\t\t\tmargin: 0px;\n\t\t\t\tfont-size: 17px;\n\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\tfont-weight: 300;\n\t\t\t}\n\n\t\t\t.btn-wrap {\n\t\t\t\tmargin-top: 40px;\n\t\t\t\ta {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tborder: 1px solid #fff;\n\t\t\t\t\tpadding: 15px 15px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\tfont-size: 11px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.copyright {\n\t\t.inner-wrap {\n\t\t\tborder-top: 1px solid #fff;\n\t\t\tmargin: 0 auto;\n\t\t\tmax-width: 90vw;\n\t\t\tpadding: 10px 0px;\n\n\t\t\tp {\n\t\t\t\tcolor: #fff;\n\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\tfont-weight: 300;\n\t\t\t\tfont-size: 12px;\n\t\t\t\ttext-align: center;\n\t\t\t}\n\t\t}\n\t}\n'], ['\n\tbackground: #000;\n\n\t> .inner-wrap {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr;\n\t\tmax-width: 90vw;\n\t\tmargin: 0 auto;\n\t\tpadding: 40px 0px;\n\t\t', ';\n\t\t.footer-logo-wrap {\n\t\t\tsvg {\n\t\t\t\tmax-width: 270px;\n\t\t\t\theight: 60px;\n\n\t\t\t\ttext,\n\t\t\t\tg {\n\t\t\t\t\tfill: #fff;\n\t\t\t\t}\n\n\t\t\t\ttext {\n\t\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tcolor: #fff;\n\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\tfont-weight: 300;\n\t\t\t\tfont-size: 13px;\n\t\t\t\tline-height: 20px;\n\t\t\t\tpadding: 0px 15px;\n\t\t\t}\n\t\t}\n\n\t\t.consult-wrap {\n\t\t\tpadding: 20px;\n\t\t\t', ';\n\t\t\th4 {\n\t\t\t\tcolor: #fff;\n\t\t\t\tmargin: 0px;\n\t\t\t\tfont-size: 17px;\n\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\tfont-weight: 300;\n\t\t\t}\n\n\t\t\t.btn-wrap {\n\t\t\t\tmargin-top: 40px;\n\t\t\t\ta {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tborder: 1px solid #fff;\n\t\t\t\t\tpadding: 15px 15px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\tfont-size: 11px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.copyright {\n\t\t.inner-wrap {\n\t\t\tborder-top: 1px solid #fff;\n\t\t\tmargin: 0 auto;\n\t\t\tmax-width: 90vw;\n\t\t\tpadding: 10px 0px;\n\n\t\t\tp {\n\t\t\t\tcolor: #fff;\n\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\tfont-weight: 300;\n\t\t\t\tfont-size: 12px;\n\t\t\t\ttext-align: center;\n\t\t\t}\n\t\t}\n\t}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['grid-template-columns: 1fr 1fr 1fr;'], ['grid-template-columns: 1fr 1fr 1fr;']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['padding: 0px;'], ['padding: 0px;']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _logo = __webpack_require__(222);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _helpers = __webpack_require__(20);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledFooter = _styledComponents2.default.footer(_templateObject, _helpers.media.medium(_templateObject2), _helpers.media.medium(_templateObject3));
	
	var Footer = function Footer() {
		return _react2.default.createElement(
			StyledFooter,
			null,
			_react2.default.createElement(
				'div',
				{ className: 'inner-wrap' },
				_react2.default.createElement(
					'div',
					{ className: 'footer-logo-wrap' },
					_react2.default.createElement(_logo2.default, null),
					_react2.default.createElement(
						'p',
						null,
						'With detailed and strict project management, a bevy of individual talent, and a whole new way of looking at R&D\u2014we\'re a forward-facing assembly of brand creatives, developers, technologists, and communicators.'
					)
				),
				_react2.default.createElement('div', { className: 'empty' }),
				_react2.default.createElement(
					'div',
					{ className: 'consult-wrap' },
					_react2.default.createElement(
						'h4',
						null,
						'Contact Us'
					),
					_react2.default.createElement(
						'div',
						{ className: 'btn-wrap' },
						_react2.default.createElement(
							_gatsbyLink2.default,
							{ to: '/contact' },
							'Request a Consultation'
						)
					)
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'copyright' },
				_react2.default.createElement(
					'div',
					{ className: 'inner-wrap' },
					_react2.default.createElement(
						'p',
						null,
						'\xA9 Wavey Media Group 2012-2018. All rights reserved. '
					)
				)
			)
		);
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\ttext-align: right;\n\n\t', ';\n'], ['\n\ttext-align: right;\n\n\t', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['display: none;'], ['display: none;']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n\tbackground: rgba(34, 34, 34, 0.9);\n\theight: 100vh;\n\twidth: 100%;\n\tposition: fixed;\n\ttop: 0;\n\tz-index: 20;\n\ttransform: translateY(100%);\n\t', ';\n\n\t&.active {\n\t\ttransform: translateY(0%);\n\t}\n\n\t> .inner-wrap {\n\t\tpadding: 100px 30px;\n\n\t\tul {\n\t\t\tlist-style: none;\n\t\t\tpadding: 0px;\n\t\t\ttext-align: left;\n\n\t\t\tli {\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t\ta {\n\t\t\t\t\tfont-size: 40px;\n\t\t\t\t\tfont-weight: 300;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n'], ['\n\tbackground: rgba(34, 34, 34, 0.9);\n\theight: 100vh;\n\twidth: 100%;\n\tposition: fixed;\n\ttop: 0;\n\tz-index: 20;\n\ttransform: translateY(100%);\n\t', ';\n\n\t&.active {\n\t\ttransform: translateY(0%);\n\t}\n\n\t> .inner-wrap {\n\t\tpadding: 100px 30px;\n\n\t\tul {\n\t\t\tlist-style: none;\n\t\t\tpadding: 0px;\n\t\t\ttext-align: left;\n\n\t\t\tli {\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t\ta {\n\t\t\t\t\tfont-size: 40px;\n\t\t\t\t\tfont-weight: 300;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n\ttext-align: center;\n\tposition: fixed;\n\twidth: 100%;\n\tz-index: 1000;\n\tpadding: 0px;\n\ttop: 0;\n\tborder-bottom: 1px solid transparent;\n\t', ';\n\t', ';\n\t', ';\n\t', ';\n\n\t> .inner-wrap {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 90% 10%;\n\t\tmax-width: 90vw;\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\t\tz-index: 2000;\n\t\t', ';\n\t}\n\n\t', ';\n\n\ta {\n\t\tcolor: #fff;\n\t\ttext-decoration: none;\n\t}\n\n\t.logo-section {\n\t\t.logo-wrap {\n\t\t\ttext-align: left;\n\t\t\tmargin: 0px auto;\n\t\t\tposition: relative;\n\t\t\tz-index: 1;\n\n\t\t\tsvg {\n\t\t\t\tmax-width: 200px;\n\t\t\t\theight: 80px;\n\t\t\t\t', ';\n\t\t\t\t', ';\n\n\t\t\t\tg,\n\t\t\t\ttext {\n\t\t\t\t\tfill: #fff;\n\t\t\t\t}\n\n\t\t\t\ttext {\n\t\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.link-section {\n\t\talign-self: center;\n\t\ttext-align: right;\n\t\tul {\n\t\t\tdisplay: none;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0px;\n\t\t\t', ';\n\n\t\t\tli {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tmargin: 0 15px;\n\n\t\t\t\ta {\n\t\t\t\t\tfont-family: \'Roboto\', sans-serif;\n\t\t\t\t\tletter-spacing: 1.5px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t', ';\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\topacity: 0.7;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.active {\n\t\tbackground: #fff;\n\t\tpadding: 0px;\n\t\tborder-color: #efefef;\n\t\t.link-section {\n\t\t\tul {\n\t\t\t\tli {\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: #777;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.logo-wrap {\n\t\t\tsvg {\n\t\t\t\tmax-width: 260px;\n\t\t\t\theight: 80px;\n\n\t\t\t\t@media (max-width: 325px) {\n\t\t\t\t\tmax-width: 210px;\n\t\t\t\t}\n\n\t\t\t\ttext {\n\t\t\t\t\tfill: #313186 !important;\n\t\t\t\t}\n\n\t\t\t\tg {\n\t\t\t\t\tfill: #1dc1e5 !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.hamburger-inner,\n\t\t.hamburger-inner::before,\n\t\t.hamburger-inner::after {\n\t\t\tbackground-color: #000;\n\t\t}\n\t}\n'], ['\n\ttext-align: center;\n\tposition: fixed;\n\twidth: 100%;\n\tz-index: 1000;\n\tpadding: 0px;\n\ttop: 0;\n\tborder-bottom: 1px solid transparent;\n\t', ';\n\t', ';\n\t', ';\n\t', ';\n\n\t> .inner-wrap {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 90% 10%;\n\t\tmax-width: 90vw;\n\t\tmargin: 0 auto;\n\t\tposition: relative;\n\t\tz-index: 2000;\n\t\t', ';\n\t}\n\n\t', ';\n\n\ta {\n\t\tcolor: #fff;\n\t\ttext-decoration: none;\n\t}\n\n\t.logo-section {\n\t\t.logo-wrap {\n\t\t\ttext-align: left;\n\t\t\tmargin: 0px auto;\n\t\t\tposition: relative;\n\t\t\tz-index: 1;\n\n\t\t\tsvg {\n\t\t\t\tmax-width: 200px;\n\t\t\t\theight: 80px;\n\t\t\t\t', ';\n\t\t\t\t', ';\n\n\t\t\t\tg,\n\t\t\t\ttext {\n\t\t\t\t\tfill: #fff;\n\t\t\t\t}\n\n\t\t\t\ttext {\n\t\t\t\t\tfont-family: \'Lato\', sans-serif;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.link-section {\n\t\talign-self: center;\n\t\ttext-align: right;\n\t\tul {\n\t\t\tdisplay: none;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0px;\n\t\t\t', ';\n\n\t\t\tli {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tmargin: 0 15px;\n\n\t\t\t\ta {\n\t\t\t\t\tfont-family: \'Roboto\', sans-serif;\n\t\t\t\t\tletter-spacing: 1.5px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t', ';\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\topacity: 0.7;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.active {\n\t\tbackground: #fff;\n\t\tpadding: 0px;\n\t\tborder-color: #efefef;\n\t\t.link-section {\n\t\t\tul {\n\t\t\t\tli {\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: #777;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.logo-wrap {\n\t\t\tsvg {\n\t\t\t\tmax-width: 260px;\n\t\t\t\theight: 80px;\n\n\t\t\t\t@media (max-width: 325px) {\n\t\t\t\t\tmax-width: 210px;\n\t\t\t\t}\n\n\t\t\t\ttext {\n\t\t\t\t\tfill: #313186 !important;\n\t\t\t\t}\n\n\t\t\t\tg {\n\t\t\t\t\tfill: #1dc1e5 !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.hamburger-inner,\n\t\t.hamburger-inner::before,\n\t\t.hamburger-inner::after {\n\t\t\tbackground-color: #000;\n\t\t}\n\t}\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['z-index: 1000;'], ['z-index: 1000;']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['padding: 25px 0px;'], ['padding: 25px 0px;']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['padding: 50px 0px;'], ['padding: 50px 0px;']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['grid-template-columns: 50% 50%;'], ['grid-template-columns: 50% 50%;']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['max-width: 300px;'], ['max-width: 300px;']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['display: block;'], ['display: block;']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(64);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _helpers = __webpack_require__(20);
	
	var _logo = __webpack_require__(222);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _Menu = __webpack_require__(234);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var MobileWrap = _styledComponents2.default.div(_templateObject, _helpers.media.large(_templateObject2));
	
	var MobileMenuWrap = _styledComponents2.default.div(_templateObject3, (0, _helpers.TransitionMixin)('.25s'));
	
	var StyledHeader = _styledComponents2.default.header(_templateObject4, _helpers.media.medium(_templateObject5), _helpers.media.medium(_templateObject6), _helpers.media.large(_templateObject7), _helpers.media.xl(_templateObject8), _helpers.media.medium(_templateObject9), (0, _helpers.TransitionMixin)('.25s'), (0, _helpers.TransitionMixin)('.25s'), _helpers.media.small(_templateObject10), _helpers.media.large(_templateObject11), (0, _helpers.TransitionMixin)('.25s'));
	
	var Header = function (_React$Component) {
		_inherits(Header, _React$Component);
	
		function Header() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, Header);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
				inMotion: false,
				mobileMenuOpen: false,
				windowPosition: 0
			}, _this.componentDidMount = function () {
				_this.checkScrollPosition();
				window.addEventListener('scroll', function () {
					_this.checkScrollPosition();
					_this.setState({
						windowPosition: window.scrollY
					});
				});
			}, _this.checkScrollPosition = function () {
				console.log('check scroll');
	
				if (window.scrollY > 50 && !_this.state.mobileMenuOpen) {
					_this.setState({
						inMotion: true
					});
				} else {
					_this.setState({
						inMotion: false
					});
				}
			}, _this.hamburgerToggle = function () {
				if (document.querySelector('#hamburger').classList.contains('is-active')) {
					_this.closeMenu();
					console.log(_this.state.mobileMenuOpen);
					if (_this.state.windowPosition > 50) {
						_this.setState({
							inMotion: true
						});
					}
				} else {
					_this.openMenu();
				}
			}, _this.openMenu = function () {
				document.querySelector('#hamburger').classList.add('is-active');
				document.querySelector('#mobile-menu-wrap').classList.add('active');
				_this.setState({
					mobileMenuOpen: true,
					inMotion: false
				});
			}, _this.closeMenu = function () {
				document.querySelector('#hamburger').classList.remove('is-active');
				document.querySelector('#mobile-menu-wrap').classList.remove('active');
				_this.setState({
					mobileMenuOpen: false
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		Header.prototype.render = function render() {
			return _react2.default.createElement(
				StyledHeader,
				{ className: this.state.inMotion ? 'active' : '' },
				_react2.default.createElement(
					'div',
					{ className: 'inner-wrap' },
					_react2.default.createElement(
						'div',
						{ className: 'logo-section' },
						_react2.default.createElement(
							'div',
							{ className: 'logo-wrap' },
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ onClick: this.closeMenu, to: '/' },
								_react2.default.createElement(_logo2.default, null)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'link-section' },
						_react2.default.createElement(_Menu2.default, null),
						_react2.default.createElement(
							MobileWrap,
							null,
							_react2.default.createElement(
								'button',
								{
									onClick: this.hamburgerToggle,
									className: 'hamburger hamburger--slider',
									id: 'hamburger'
								},
								_react2.default.createElement(
									'div',
									{ className: 'hamburger-box' },
									_react2.default.createElement('div', { className: 'hamburger-inner' })
								)
							)
						)
					)
				),
				_react2.default.createElement(
					MobileMenuWrap,
					{ id: 'mobile-menu-wrap' },
					_react2.default.createElement(
						'div',
						{ className: 'inner-wrap' },
						_react2.default.createElement(_Menu2.default, { toggle: this.hamburgerToggle })
					)
				)
			);
		};
	
		return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledMenu = _styledComponents2.default.ul(_templateObject);
	
	var Menu = function Menu(_ref) {
		var children = _ref.children,
		    toggle = _ref.toggle;
	
		return _react2.default.createElement(
			StyledMenu,
			null,
			_react2.default.createElement(
				'ul',
				null,
				_react2.default.createElement(
					'li',
					null,
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ onClick: toggle, to: '/work' },
						'Work'
					)
				),
				_react2.default.createElement(
					'li',
					null,
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ onClick: toggle, to: '/about' },
						'About'
					)
				),
				_react2.default.createElement(
					'li',
					null,
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ onClick: toggle, to: '/contact' },
						'Contact'
					)
				)
			)
		);
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\tpadding: 0rem;\n\tbackground: #fff;\n\t/* .content-wrap {\n\t\tpadding-top: 110px;\n\t} */\n'], ['\n\tpadding: 0rem;\n\tbackground: #fff;\n\t/* .content-wrap {\n\t\tpadding-top: 110px;\n\t} */\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(34);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(9);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	__webpack_require__(330);
	
	var _Header = __webpack_require__(233);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(232);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Main = _styledComponents2.default.main(_templateObject);
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
		var children = _ref.children,
		    data = _ref.data,
		    location = _ref.location;
		return _react2.default.createElement(
			Main,
			null,
			_react2.default.createElement(_reactHelmet2.default, {
				title: 'Wavey Media Group | Digital Brand Stategy \uD83D\uDD76\uFE0F',
				link: [{
					rel: 'stylesheet',
					href: 'https://fonts.googleapis.com/css?family=Work+Sans:300,400,700|Roboto:300,400,500,700|Lato:300,400,500,700'
				}, {
					rel: 'stylesheet',
					href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css'
				}, {
					rel: 'stylesheet',
					href: 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css'
				}]
			}),
			_react2.default.createElement(_Header2.default, { logo: data.logo }),
			children(),
			_react2.default.createElement(_Footer2.default, { logo: data.logo })
		);
	};
	
	TemplateWrapper.propTypes = {
		children: _propTypes2.default.func
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = TemplateWrapper;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-8bf43fbd5a80e68f07fb.js